import { Colors } from "../constants/colors";

export default {
  variants: [
    {
      props: { variant: "gridUrlRender" },
      style: {
        textDecoration: "none",
        color: Colors.BLUE500,
      },
    },
    {
      props: { variant: "blue" },
      style: {
        color: Colors.BLUE500,
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline",
        },
        cursor: "pointer",
      },
    },
  ],
};
